<template>
  <div class="video-block" v-if="url.includes('iframe')">
    <div v-html="url"></div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      required: true,
      type: String
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.video-block {
  // border: 2px solid black;
  position: relative;
  width: 100%;
  padding-bottom: 50%;
  margin-top: 20px;
  margin-bottom: 20px;
  iframe,
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
